<div class="panel-auth fadeIn">
    <div class="auth-card shadow-soft">
        <h2 style="text-align: center;" class="titulo">REGISTRAR NUEVO USUARIO</h2>
        <BR>

        <form (ngSubmit)="RegistrarUsuario(f,usuario.email); f.resetForm()" #f="ngForm" class="auth-form">

            <!-- Correo -->
            <div class="form-block">
                <label>Correo electrónico</label>
                <input [(ngModel)]="usuario.email" class="input-uiv" type="email" name="email" required email placeholder="Correo institucional" #email="ngModel" />
                <small *ngIf="email.invalid && email.touched" class="error-msg">Escriba un correo válido</small>
            </div>

            <!-- Contraseña -->
            <div class="form-block">
                <label>Nueva contraseña</label>
                <input [(ngModel)]="usuario.password" class="input-uiv" type="password" name="password" required minlength="3" placeholder="Mínimo 3 caracteres" #password="ngModel" />
                <small *ngIf="password.invalid && password.touched" class="error-msg">Ingrese mínimo 3 caracteres</small>
            </div>

            <!-- Nombre -->
            <div class="form-block">
                <label>Nombre del usuario</label>
                <input [(ngModel)]="usuario.nombre" class="input-uiv" type="text" name="nombre" required placeholder="Nombre completo" #nombre="ngModel" />
                <small *ngIf="nombre.invalid && nombre.touched" class="error-msg">Campo obligatorio</small>
            </div>

            <!-- Número empleado -->
            <div class="form-block">
                <label>Número de empleado</label>
                <input [(ngModel)]="usuario.numemp" class="input-uiv" type="text" name="numemp" required placeholder="No. empleado" #numempleado="ngModel" />
                <small *ngIf="numempleado.invalid && numempleado.touched" class="error-msg">Campo obligatorio</small>
            </div>

            <!-- Cargo -->
            <div class="form-block">
                <label>Tipo de usuario</label>
                <select [(ngModel)]="usuario.cargo" name="cargo" class="select-uiv" required #cargo="ngModel">
          <option [ngValue]="cargos.idcargo" *ngFor="let cargos of Cargos">{{ cargos.cargo }}</option>
        </select>
                <small *ngIf="cargo.invalid && cargo.touched" class="error-msg">Campo obligatorio</small>
            </div>

            <!-- Plantel -->
            <div class="form-block">
                <label>Plantel</label>
                <select [(ngModel)]="usuario.idplantel" name="plantel" class="select-uiv" required #plantel="ngModel" disabled>
          <option [ngValue]="item.idplantel" *ngFor="let item of ListarEquipo">{{ item.nombreplantel }}</option>
        </select>
                <small *ngIf="plantel.invalid && plantel.touched" class="error-msg">Campo obligatorio</small>
            </div>

            <button type="submit" class="btn-uiv">Crear cuenta</button>

        </form>
    </div>
</div>